import * as cx from 'classnames';
import { FORMS_DEFAULT_REQUIRED_FIELD_ERROR } from 'mk/autogenerated/translations/Checkbox.9c809d913e67b257cac9e9ee389ea0ed'
import FieldWrapper from 'mk/forms/FieldWrapper';
import * as React from 'react';

interface OwnProps {
    className?: string;
    itemClassName?: string;
    name: string;
    initial?: boolean;
    errors?: string[];
    label?: string;
    autofocus?: boolean;
    itemLabel?: string;
    required?: boolean;

    onChange?(value: boolean);
}

interface State {
    value: boolean;
}

export class Checkbox extends React.Component<OwnProps, State> {

    public static defaultProps = {
        initial: false,
    };

    public static isFormField() {
        return true;
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            value: props.initial,
        };
    }

    public validate() {
        if (this.props.required && !this.state.value) {
            return [null, [FORMS_DEFAULT_REQUIRED_FIELD_ERROR]];
        }

        return [this.state.value, null];
    }

    public clear() {
        if (!this.hasValue()) {
            return;
        }

        this.setState({
            value: this.props.initial,
        });

        // Notify parent about change
        if (this.props.onChange) {
            this.props.onChange(this.props.initial);
        }
    }

    public hasValue() {
        return this.state.value && (!Array.isArray(this.state.value) || this.state.value.length > 0);
    }

    public getValue() {
        return this.state.value;
    }

    public setValue(value) {
        this.setState({ value });
    }

    public render() {
        return (
            <FieldWrapper
                className={cx('checkbox', this.props.className)}
                label={this.props.label}
                errors={this.props.errors}
                name={this.props.name}
            >
                <label
                    className={cx('input-label', this.props.itemClassName)}
                    htmlFor={this.props.name}
                >
                    <input
                        id={this.props.name}
                        type="checkbox"
                        name={this.props.name}
                        onChange={this.onChange}
                        checked={this.state.value}
                    />
                    {this.props.itemLabel}
                </label>
            </FieldWrapper>
        );
    }

    private onChange = (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({value: event.currentTarget.checked});
        // Notify parent about change
        if (this.props.onChange) {
            this.props.onChange(event.currentTarget.checked);
        }
    };

}
